import {initializeApp} from 'firebase/app'
import {getMessaging, isSupported as isMessagingSupported} from 'firebase/messaging'

const firebaseConfig = {
  apiKey: "AIzaSyCv3Ws8SQ5fGIe8_ZVh7nlczivEaIg_ZFw",
  authDomain: "boostaminophen-d8f66.firebaseapp.com",
  projectId: "boostaminophen-d8f66",
  storageBucket: "boostaminophen-d8f66.firebasestorage.app",
  messagingSenderId: "184924580007",
  appId: "1:184924580007:web:7488cfa844473896ff9382",
  measurementId: "G-1YX7Z8B15T"
};

const app = initializeApp(firebaseConfig)

let messagingPromise;

export function getFirebaseMessaging() {
  if (!messagingPromise) {
    messagingPromise = isMessagingSupported()
      .then((supported) => supported ? getMessaging(app) : null)
      .catch((error) => {
        console.warn('Firebase Messaging is not available in this browser.', error)
        return null
      })
  }

  return messagingPromise
}
